'use client';

import { c as _c } from "react/compiler-runtime";
import { Icon, type IconNames, SkeletonBar, TextPassage } from '@petsmart-ui/sparky';
import cn from 'classnames';
import type { InputHTMLAttributes, ReactNode, RefAttributes } from 'react';
import type { FulfillmentMethod, FulfillmentStatus } from '../lib';
import { CarIcon } from './car-icon';
import './fulfillment-tile.scss';
const STATUS_TONE_CLASS_NAMES: Record<NonNullable<FulfillmentStatus['tone']>, string> = {
  success: 'sparky-u-color-utility-success',
  error: 'sparky-u-color-utility-error'
};
type FulfillmentTileProps = Readonly<{
  value: FulfillmentMethod;
  title: ReactNode;
  iconName: IconNames | 'car-outline';
  status?: FulfillmentStatus;
  isDisabled?: boolean;
  isLoading?: boolean;
  isSelected: boolean;
  statusTestId?: string;
  inputProps?: InputHTMLAttributes<HTMLInputElement> & RefAttributes<HTMLInputElement>;
}>;
export const FulfillmentTile = t0 => {
  const $ = _c(49);
  let iconName;
  let inputProps;
  let isSelected;
  let props;
  let status;
  let statusTestId;
  let t1;
  let t2;
  let title;
  let value;
  if ($[0] !== t0) {
    ({
      value,
      title,
      iconName,
      status,
      isSelected,
      isDisabled: t1,
      isLoading: t2,
      statusTestId,
      inputProps,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = iconName;
    $[2] = inputProps;
    $[3] = isSelected;
    $[4] = props;
    $[5] = status;
    $[6] = statusTestId;
    $[7] = t1;
    $[8] = t2;
    $[9] = title;
    $[10] = value;
  } else {
    iconName = $[1];
    inputProps = $[2];
    isSelected = $[3];
    props = $[4];
    status = $[5];
    statusTestId = $[6];
    t1 = $[7];
    t2 = $[8];
    title = $[9];
    value = $[10];
  }
  const isDisabled = t1 === undefined ? false : t1;
  const isLoading = t2 === undefined ? false : t2;
  const t3 = `${value} delivery-tile`;
  let t4;
  if ($[11] !== isDisabled || $[12] !== isSelected || $[13] !== t3) {
    t4 = cn(t3, {
      disabled: isDisabled,
      selected: isSelected
    });
    $[11] = isDisabled;
    $[12] = isSelected;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  const className = t4;
  let t5;
  if ($[15] !== iconName || $[16] !== isDisabled) {
    t5 = () => {
      if (iconName === "car-outline") {
        return <CarIcon isDisabled={isDisabled} />;
      }
      return <Icon data-testid="delivery-tile-icon" name={iconName} className={`delivery-tile__icon ${isDisabled ? "disabled" : ""}`} size="md" />;
    };
    $[15] = iconName;
    $[16] = isDisabled;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  const renderIcon = t5;
  let t6;
  if ($[18] !== isDisabled || $[19] !== isLoading || $[20] !== status || $[21] !== statusTestId) {
    t6 = () => {
      if (isLoading) {
        return <SkeletonBar data-testid="delivery-tile-skeleton" size="sm" />;
      }
      if (isDisabled) {
        return <TextPassage className="sparky-u-color-utility-error" size="sm">Not available</TextPassage>;
      }
      if (!status) {
        return null;
      }
      return <TextPassage data-testid={statusTestId} className={status.tone && STATUS_TONE_CLASS_NAMES[status.tone]} size="sm">{status.message}</TextPassage>;
    };
    $[18] = isDisabled;
    $[19] = isLoading;
    $[20] = status;
    $[21] = statusTestId;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  const renderStatus = t6;
  const t7 = `${value}-tile`;
  let t8;
  if ($[23] !== inputProps || $[24] !== isDisabled || $[25] !== isSelected || $[26] !== props || $[27] !== value) {
    t8 = <input type="radio" value={value} checked={isSelected} className="hidden-input" disabled={isDisabled} {...props} {...inputProps} />;
    $[23] = inputProps;
    $[24] = isDisabled;
    $[25] = isSelected;
    $[26] = props;
    $[27] = value;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  let t9;
  if ($[29] !== isSelected) {
    t9 = isSelected && <svg data-testid="delivery-tile-checkmark" xmlns="http://www.w3.org/2000/svg" width="11" height="8" viewBox="0 0 10 8" fill="none" className="delivery-tile__checkmark-icon"><path d="M3.56756 7.3997C3.55932 7.3997 3.55116 7.3997 3.54292 7.3989C3.34564 7.39266 3.15892 7.30282 3.03044 7.15434L0.347959 4.09378C0.129559 3.84458 0.154599 3.46562 0.403799 3.2473C0.652599 3.02778 1.03196 3.05354 1.25028 3.30314L3.59292 5.97618L8.7742 0.776181C9.0078 0.541781 9.38828 0.540261 9.62268 0.774581C9.8578 1.00858 9.8578 1.38826 9.62428 1.62298L4.08164 7.18546C3.94612 7.32218 3.7598 7.3997 3.56756 7.3997ZM3.93124 6.36138L3.93556 6.36682C3.93396 6.36522 3.93284 6.3629 3.93124 6.36138ZM3.23196 6.33802C3.23156 6.33882 3.23116 6.33962 3.23036 6.33962L3.23196 6.33802Z" fill="white" opacity={1} /></svg>;
    $[29] = isSelected;
    $[30] = t9;
  } else {
    t9 = $[30];
  }
  let t10;
  if ($[31] !== renderIcon) {
    t10 = renderIcon();
    $[31] = renderIcon;
    $[32] = t10;
  } else {
    t10 = $[32];
  }
  let t11;
  if ($[33] !== title) {
    t11 = <TextPassage className="sparky-u-theme-typography-body-lg-bold">{title}</TextPassage>;
    $[33] = title;
    $[34] = t11;
  } else {
    t11 = $[34];
  }
  let t12;
  if ($[35] !== renderStatus) {
    t12 = renderStatus();
    $[35] = renderStatus;
    $[36] = t12;
  } else {
    t12 = $[36];
  }
  let t13;
  if ($[37] !== t12) {
    t13 = <div data-testid="delivery-tile-status-content" className="delivery-tile__content-status">{t12}</div>;
    $[37] = t12;
    $[38] = t13;
  } else {
    t13 = $[38];
  }
  let t14;
  if ($[39] !== t10 || $[40] !== t11 || $[41] !== t13) {
    t14 = <div className="delivery-tile__content">{t10}{t11}{t13}</div>;
    $[39] = t10;
    $[40] = t11;
    $[41] = t13;
    $[42] = t14;
  } else {
    t14 = $[42];
  }
  let t15;
  if ($[43] !== className || $[44] !== t14 || $[45] !== t7 || $[46] !== t8 || $[47] !== t9) {
    t15 = <label className={className} data-testid={t7}>{t8}{t9}{t14}</label>;
    $[43] = className;
    $[44] = t14;
    $[45] = t7;
    $[46] = t8;
    $[47] = t9;
    $[48] = t15;
  } else {
    t15 = $[48];
  }
  return t15;
};